import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { recruitingEffects } from './effects';
import { recruitingFeatureKey, reducers } from './reducers';

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        StoreModule.forFeature(recruitingFeatureKey, reducers),
        EffectsModule.forFeature(recruitingEffects)
    ]
})
export class RecruitingStoreModule {}
